import React from 'react';
import PropTypes from 'prop-types';

import { BOLD_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { BOLD_TAG_NAME } from './constants';

const Bold = ({ className, BOLD_TAG = BOLD_TAG_NAME, ...attributes }) => {
  const RenderLeaf = ({ leaf, children, attributes: elementAttributes }) => {
    if (leaf[BOLD_DEFINITIONS.type]) {
      return (
        <BOLD_TAG {...attributes} {...elementAttributes} className={className}>
          {children}
        </BOLD_TAG>
      );
    }
    return children;
  };
  return RenderLeaf;
};

Bold.propTypes = {
  children: PropTypes.node.isRequired,
  leaf: PropTypes.string,
};

export { Bold };
